module.exports = __webpack_public_path__ + "static/montecapriolo-1319b18e97dd23c3f7cdb9f8341cab09.jpeg";